import React, { useEffect, useState } from "react";
import { supabase } from "../services/supabase";

const PAGE_SIZE = 15;

const ClientsPage = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClient, setSelectedClient] = useState(null);

  // 🔍 Recherche + pagination (CLIENT SIDE)
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  /* ===============================
     LOAD CLIENTS (SANS SEARCH SQL)
     =============================== */
  const loadClients = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("clients")
      .select(`
        id,
        created_at,
        address,
        city,
        zipcode,
        favourite_address,
        profiles:profiles(full_name, phone, email)
      `)
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Erreur load clients:", error);
      setClients([]);
    } else {
      setClients(data || []);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadClients();
  }, []);

  /* ===============================
     🔍 FILTRAGE CLIENT-SIDE
     =============================== */
  const filteredClients = clients.filter((client) => {
    const q = search.toLowerCase();
    return (
      client.profiles?.full_name?.toLowerCase().includes(q) ||
      client.profiles?.phone?.toLowerCase().includes(q) ||
      client.profiles?.email?.toLowerCase().includes(q)
    );
  });

  /* ===============================
     📄 PAGINATION CLIENT-SIDE
     =============================== */
  const totalPages = Math.ceil(filteredClients.length / PAGE_SIZE);

  const paginatedClients = filteredClients.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  return (
    <div>
      <h2>Clients</h2>

      {/* 🔍 TOOLBAR */}
      <div className="rides-toolbar">
        <input
          type="text"
          placeholder="Rechercher (nom, téléphone, email)"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </div>

      {loading ? (
        <p>Chargement…</p>
      ) : paginatedClients.length === 0 ? (
        <p>Aucun client trouvé.</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Téléphone</th>
                <th>Email</th>
                <th>Adresse</th>
                <th>Ville</th>
                <th>Code Postal</th>
                <th>Créé le</th>
                <th>Détails</th>
              </tr>
            </thead>

            <tbody>
              {paginatedClients.map((client) => (
                <tr key={client.id}>
                  <td>{client.profiles?.full_name || "—"}</td>
                  <td>{client.profiles?.phone || "—"}</td>
                  <td>{client.profiles?.email || "—"}</td>
                  <td>{client.address || "—"}</td>
                  <td>{client.city || "—"}</td>
                  <td>{client.zipcode || "—"}</td>
                  <td>
                    {new Date(client.created_at).toLocaleDateString()}
                  </td>
                  <td>
                    <button
                      className="btn-secondary"
                      onClick={() => setSelectedClient(client)}
                    >
                      Voir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* 📄 PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                ← Précédent
              </button>

              <span>
                Page {page} / {totalPages}
              </span>

              <button
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Suivant →
              </button>
            </div>
          )}
        </>
      )}

      {/* 🔥 MODAL DÉTAILS CLIENT */}
      {selectedClient && (
        <div className="modal-backdrop">
          <div className="modal-card">
            <h3>Détails du client</h3>

            <p>
              <strong>Nom :</strong>{" "}
              {selectedClient.profiles?.full_name}
            </p>
            <p>
              <strong>Téléphone :</strong>{" "}
              {selectedClient.profiles?.phone}
            </p>
            <p>
              <strong>Email :</strong>{" "}
              {selectedClient.profiles?.email}
            </p>

            <hr />

            <p>
              <strong>Adresse :</strong>{" "}
              {selectedClient.address || "—"}
            </p>
            <p>
              <strong>Ville :</strong>{" "}
              {selectedClient.city || "—"}
            </p>
            <p>
              <strong>Code Postal :</strong>{" "}
              {selectedClient.zipcode || "—"}
            </p>
            <p>
              <strong>Adresse favorite :</strong>{" "}
              {selectedClient.favourite_address || "—"}
            </p>

            <p>
              <strong>Créé le :</strong>{" "}
              {new Date(selectedClient.created_at).toLocaleString()}
            </p>

            <div style={{ marginTop: 20, textAlign: "right" }}>
              <button
                className="btn-danger"
                onClick={() => setSelectedClient(null)}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientsPage;


